import React from 'react'
import { Link } from 'react-router-dom'
import utils from '../utils';
import { Helmet } from 'react-helmet';

function PageNotFound() {
    const url = typeof window !== 'undefined' ? window.location.href : '';
    return (
        <div>
            <Helmet>
                <title>Page Not Found - {utils.siteName}</title>
                <link rel="canonical" href={url} />
            </Helmet>
            <div className="flex-grow flex flex-col items-center justify-center w-full px-4 py-12 md:py-20">
                <div className="layout-content-container flex flex-col max-w-[960px] w-full flex-1 gap-12">

                    <div className="flex flex-col items-center text-center gap-8 animate-fade-in-up">

                        <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-primary/10">

                            <div className="absolute top-[-20%] right-[-20%] w-64 h-64 bg-primary/20 rounded-full blur-3xl"></div>
                            <div className="absolute bottom-[-20%] left-[-20%] w-64 h-64 bg-accent-red/20 rounded-full blur-3xl"></div>
                            <div className="relative not-found-bg z-5 w-full h-full bg-center bg-cover bg-no-repeat" data-alt="3D playful illustration of a floating cardboard box in space with orange accent lighting">
                                <div className="absolute inset-0 bg-gradient-to-t from-background-light/80 to-transparent dark:from-background-dark/80"></div>
                            </div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <h1 className="text-[120px] md:text-[160px] font-extrabold text-white mix-blend-overlay opacity-90 leading-none select-none">404</h1>
                            </div>
                        </div>
                        <div className="flex max-w-[560px] flex-col items-center gap-4 relative z-10">
                            <p className="text-accent-red dark:text-red-400 text-lg font-bold uppercase tracking-wider">Error 404</p>
                            <h1 className="text-[#1c160d] dark:text-white text-4xl md:text-5xl font-extrabold leading-tight tracking-[-0.02em]">
                                Oops! You've gone off the map.
                            </h1>
                            <p className="text-gray-600 dark:text-gray-300 text-lg font-normal leading-relaxed">
                                We can't find the page you're looking for, but don't worry—our warehouse is still full of treasures waiting to be discovered.
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4 w-full justify-center max-w-[480px]">
                            <Link className="flex flex-1 cursor-pointer items-center justify-center rounded-xl h-12 px-6 bg-primary hover:bg-orange-600 text-white text-base font-bold leading-normal tracking-[0.015em] transition-all shadow-lg shadow-primary/25 transform hover:-translate-y-0.5" to="/">
                                Return to Homepage
                            </Link>
                            {/* <a className="flex flex-1 cursor-pointer items-center justify-center rounded-xl h-12 px-6 bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 text-[#1c160d] dark:text-white hover:bg-gray-50 dark:hover:bg-white/10 text-base font-bold leading-normal tracking-[0.015em] transition-all" href="#">
                            Contact Support
                        </a> */}
                        </div>
                        {/* <div className="w-full max-w-[480px] mt-2">
                            <div className="relative group">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                    <span className="material-symbols-outlined text-gray-400 group-focus-within:text-primary transition-colors">search</span>
                                </div>
                                <input className="block w-full pl-12 pr-4 py-3.5 rounded-xl border-none bg-white dark:bg-white/5 shadow-sm ring-1 ring-gray-200 dark:ring-white/10 focus:ring-2 focus:ring-primary placeholder:text-gray-400 dark:text-white sm:text-sm sm:leading-6 transition-all" placeholder="Or search for exactly what you need..." type="text" />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound